import { CUSTOMER_API_HEADERS, SHOPIFY_HEADERS, apiPrefixedHost } from "@smartrr/shared/constants";
import { customerContract } from "@smartrr/shared/contracts/customer";
import { initClient, tsRestFetchApi } from "@ts-rest/core";
import { getStoreValidation } from "./utils";
import { ensureShopifyGid } from "@smartrr/shared/utils/ensureShopifyGid";

export const SmartrrApi = initClient(customerContract, {
  baseUrl: `https://${apiPrefixedHost}/v2`,
  credentials: "omit",
  baseHeaders: {
    "Content-Type": "application/json",

    /**
     * Default arg values. Filled by the middleware below
     */
    "x-shopify-customer-id": "gid://shopify/Customer/0",
    "x-shopify-shop-domain": "",
    "x-customer-portal-signature": "",
    "x-customer-portal-exp": "0",
  },
  api(args) {
    const validation = getStoreValidation();
    if (validation?.hasSignature) {
      args.headers[CUSTOMER_API_HEADERS.SHOPIFY_CUSTOMER_ID] = ensureShopifyGid("Customer", validation.shopifyId);
      args.headers[SHOPIFY_HEADERS.SHOP_DOMAIN] = validation.myShopifyDomain;
      args.headers[CUSTOMER_API_HEADERS.SIGNATURE] = validation.signature;
      args.headers[CUSTOMER_API_HEADERS.EXPIRATION] = validation.exp;

      if (validation.adminShopifyId) {
        args.headers[CUSTOMER_API_HEADERS.ADMIN_PREVIEW_ID] = ensureShopifyGid(
          "Customer",
          validation.adminShopifyId
        );
      }
    } else {
      throw new Error("Customer not validated");
    }

    return tsRestFetchApi(args);
  },
});
